import {Link, Stack, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import PlanetIcon from '../Logo/Icon.jsx';

/**
 * Displays the Planet icon accompanied by an optional title
 * On smaller screens only the icon is displayed.
 */
const ProductHome = ({href, title}) => {
  return (
    <Link href={href} underline="none" color="inherit">
      <Stack
        direction="row"
        sx={{
          gap: 1,
          alignItems: 'center',
          paddingX: 1,
          paddingY: 0.75,
        }}
        title={title}
      >
        <PlanetIcon />
        {title && (
          <Typography
            variant="subtitle2"
            sx={{
              display: {
                xs: 'none',
                sm: 'inline',
              },
            }}
          >
            {title}
          </Typography>
        )}
      </Stack>
    </Link>
  );
};

ProductHome.propTypes = {
  /**
   * home url
   */
  href: PropTypes.string,

  /** product title */
  title: PropTypes.string,
};

export default ProductHome;
